import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';

interface Props<T = unknown> {
  modelValue: T;
  options: T[];
  label?: string;
  placeholder?: string;
  icon?: string;
  outlined?: boolean;
  dense?: boolean;
  disabled?: boolean;
  readonly?: boolean;
  multiple?: boolean;
  clearable?: boolean;
  loading?: boolean;
  optionLabel?: string;
  optionValue?: string;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
  size?: 'sm' | 'md' | 'lg';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DSSelect',
  props: {
    modelValue: {},
    options: {},
    label: { default: '' },
    placeholder: { default: '' },
    icon: { default: '' },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    optionLabel: { default: 'label' },
    optionValue: { default: 'value' },
    error: { type: Boolean, default: false },
    errorMessage: { default: '' },
    helperText: { default: '' },
    size: { default: 'md' }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props;





const internalValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const hasError = computed(() => props.error || !!props.errorMessage);

const classes = computed(() => ({
  'ds-select--sm': props.size === 'sm',
  'ds-select--lg': props.size === 'lg',
}));

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    modelValue: internalValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
    options: _ctx.options,
    label: _ctx.label,
    placeholder: _ctx.placeholder,
    outlined: _ctx.outlined,
    dense: _ctx.dense,
    disable: _ctx.disabled,
    readonly: _ctx.readonly,
    multiple: _ctx.multiple,
    clearable: _ctx.clearable,
    loading: _ctx.loading,
    "option-label": _ctx.optionLabel,
    "option-value": _ctx.optionValue,
    "emit-value": true,
    "map-options": true,
    error: hasError.value,
    "error-message": _ctx.errorMessage,
    hint: _ctx.helperText,
    color: _ctx.error ? 'negative' : 'primary',
    "bottom-slots": !!_ctx.helperText || !!_ctx.errorMessage,
    class: classes.value
  }, _ctx.$attrs), _createSlots({
    option: _withCtx((scope) => [
      _createVNode(_component_q_item, _mergeProps(scope.itemProps, { dense: _ctx.dense }), {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.opt[props.optionLabel]), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1040, ["dense"])
    ]),
    hint: _withCtx(() => [
      _renderSlot(_ctx.$slots, "hint", {}, () => [
        _createElementVNode("span", {
          class: _normalizeClass({ 'text-negative': hasError.value })
        }, _toDisplayString(_ctx.helperText), 3)
      ])
    ]),
    _: 2
  }, [
    (_ctx.icon)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _createVNode(_component_q_icon, { name: _ctx.icon }, null, 8, ["name"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["modelValue", "options", "label", "placeholder", "outlined", "dense", "disable", "readonly", "multiple", "clearable", "loading", "option-label", "option-value", "error", "error-message", "hint", "color", "bottom-slots", "class"]))
}
}

})